import React from 'react'
import * as S from './styles'
import { trans } from '@zing/shared/i18n'
import { TENANT_SHORT_NAME } from '@zing/shared/constants/zingConfigInfo'
import { TENANT_CONTACT_EMAIL } from '../../../../constants/guaxupeConfigInfo'
import { useAuthLayout } from '@zing/shared/hooks/useAuthLayout'

export const HotsiteFooter = (): React.ReactElement => {
  const { logoUrlWhite } = useAuthLayout()

  const labels = {
    emailContact: `${trans('Contate-nos')}: ${TENANT_CONTACT_EMAIL}`,
    rightsReserved: trans('Todos os direitos reservados'),
    copyright: trans('Copyright')
  }

  return (
    <S.FooterWrapper>
      <S.FooterLinksWrapper>
        <a className="d-flex w-full align-items-center justify-content-center mt-4">
          <S.FooterLogo src={logoUrlWhite} loading="lazy" alt="Hub GXP" />
        </a>
        <S.FooterHr />
        <S.FooterEmail>{labels.emailContact}</S.FooterEmail>
        <S.FooterCopyright>
          {`${labels.copyright} © 2022 ${TENANT_SHORT_NAME.toUpperCase()}. ${labels.rightsReserved}`}
        </S.FooterCopyright>
      </S.FooterLinksWrapper>
    </S.FooterWrapper>
  )
}
